import config from "@/config";
import { handleAndTrackError } from "@/lib/helper";
import { useToast } from "../ui/use-toast";
import { useNavigate } from 'react-router-dom';

// export const clickKycAction = async () => {
//   try {
//     const response = await fetch(`${config.API_URL}/ekyc/start-kyc/`, {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem(
//           config.LOCAL_KEYS.SIGNUP_TOKEN
//         )}`,
//       },
//     });

//     if (!response.ok) {
//       const errorData = await response.json().catch(() => ({}));
//       const errorMessage = errorData.message || "Failed to start KYC session.";
//       const error = new Error(errorMessage);

//       handleAndTrackError(error, {
//         apiPath: "/ekyc/start-kyc/",
//         responseStatus: response.status,
//         responseError: errorData,
//       });
//     }

//     const data = await response.json();

//     if (data?.sessionUrl) {
//       // window.location.href = data.sessionUrl;
//     } else if (data?.data?.name) {
//       // window.location.href = '/kyc';
//     }
//     else {
//       const errorMessage = "KYC session URL is missing.";
//       handleAndTrackError(new Error(errorMessage), {
//         apiPath: "/ekyc/start-kyc/",
//         responseData: data,
//       });
//     }
//   } catch (error) {
//     handleAndTrackError(error, {
//       apiPath: "/ekyc/start-kyc/",
//     });
//   }
// };

export const clickMandateAction = async () => {
  try {
    const response = await fetch(`${config.API_URL}/emandate/setup`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          config.LOCAL_KEYS.SIGNUP_TOKEN
        )}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      const errorMessage = errorData.message || "Failed to start Mandate session.";
      const error = new Error(errorMessage);


      handleAndTrackError(error, {
        apiPath: "/emandate/setup",
        responseStatus: response.status,
        responseError: errorData,
      });
      // Stop here. The body is already read, and reading it again below threw "body stream
      // already read" — which replaced the server's message in the tenant's toast.
      error.tracked = true;
      throw error;
    }

    const data = await response.json();

    if (data?.sessionUrl) {
      if (data.mode === "new-tab") return data;
      window.location.href = data.sessionUrl;
      return data;
    }
    // No link means nothing to open: throw so the page shows an error instead of a Continue
    // button that silently does nothing (DIL-135, 1 Oct 2026). cpcore now answers this case
    // with a 400 + message; this guards older responses and any other path that returns null.
    const error = new Error(
      "We could not start your auto-debit set-up. Please check that your email address and bank details are correct, or contact support."
    );
    handleAndTrackError(error, {
      apiPath: "/emandate/setup",
      responseData: data,
    });
    error.tracked = true;
    throw error;
  } catch (error) {
    if (!error?.tracked) {
      handleAndTrackError(error, {
        apiPath: "/emandate/setup`",
      });
    }
    throw error
  }
};
